class FankaContact20 extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const sectionId = this.dataset.sectionId || 'contact';
    const tabList = this.querySelector('.faq-list-item');
    this.tabs = Array.from(this.querySelectorAll('.faq-list-item > li'));
    this.panels = Array.from(this.querySelectorAll('.faq-show-item-list'));
    this.items = Array.from(this.querySelectorAll('.faq-show-item'));

    tabList?.setAttribute('role', 'tablist');

    this.tabs.forEach((tab, index) => {
      const tabId = `FankaContactTab-${sectionId}-${index}`;
      const panelId = `FankaContactPanel-${sectionId}-${index}`;
      tab.setAttribute('role', 'tab');
      tab.id = tabId;
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      tab.addEventListener('click', () => this.selectTab(index));
      tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
    });

    this.panels.forEach((panel, index) => {
      panel.setAttribute('role', 'tabpanel');
      panel.id = `FankaContactPanel-${sectionId}-${index}`;
      panel.setAttribute('aria-labelledby', `FankaContactTab-${sectionId}-${index}`);
      panel.hidden = index !== 0;
      panel.style.removeProperty('display');
    });

    this.items.forEach((item) => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-expanded', 'false');
      item.addEventListener('click', () => this.toggleItem(item));
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.toggleItem(item);
      });
    });

    this.querySelector('.fanka-contact-back-to-top')?.addEventListener('click', (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  selectTab(index) {
    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle('active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });
  }

  onTabKeydown(event, index) {
    let nextIndex = index;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = this.tabs.length - 1;
    else return;

    event.preventDefault();
    this.selectTab(nextIndex);
    this.tabs[nextIndex].focus();
  }

  toggleItem(item) {
    const answer = item.nextElementSibling;
    if (!(answer instanceof HTMLElement)) return;

    const open = !item.classList.contains('faq-show-item-active');
    item.classList.toggle('faq-show-item-active', open);
    item.setAttribute('aria-expanded', String(open));
    answer.style.display = open ? 'block' : 'none';

    item.querySelectorAll('.plus').forEach((icon) => {
      icon.style.display = open ? 'none' : 'block';
    });
    item.querySelectorAll('.minus').forEach((icon) => {
      icon.style.display = open ? 'block' : 'none';
    });
  }
}

if (!customElements.get('fanka-contact-2-0')) {
  customElements.define('fanka-contact-2-0', FankaContact20);
}
